const Saetze = require('./saetze.js');
import {formatPrice} from './logic.js';

class Wohnzuschuss {

    constructor()
    {
        this.stud_allein = Saetze.saetze.b.wohnzuschuss;
        this.stud_eltern = Saetze.saetze.c.wohnzuschuss;
        this.schule_abi = Saetze.saetze.d.wohnzuschuss;
        this.schule_abend = Saetze.saetze.e.wohnzuschuss;
        this.schule_fach = Saetze.saetze.f.wohnzuschuss;
        this.schule_kolleg = Saetze.saetze.g.wohnzuschuss;
        this.meister = Saetze.saetze.aufstiegsbafoeg.wohnzuschuss;
    }

    get student_allein() {
        return this.berechneStudentAllein();
    }
    get student_eltern() {
        return this.berechneStudentEltern();
    }
    get abitur() {
        return this.berechneSchuelerAbitur();
    }
    get abend() {
        return this.berechneSchuelerAbendschule();
    }
    get fachschule() {
        return this.berechneSchuelerFachschule();
    }
    get kolleg() {
        return this.berechneSchuelerKolleg();
    }
    get aufstieg() {
        return this.berechneMeister();
    }
    get null() {
        return this.berechneNull();
    }

    berechneStudentAllein() {
        return formatPrice(this.stud_allein);
    }
    berechneStudentEltern() {
        return formatPrice(this.stud_eltern);
    }
    berechneSchuelerAbitur() {
        return formatPrice(this.schule_abi);
    }
    berechneSchuelerAbendschule() {
        return formatPrice(this.schule_abend);
    }
    berechneSchuelerFachschule() {
        return formatPrice(this.schule_fach);
    }
    berechneSchuelerKolleg() {
        return formatPrice(this.schule_kolleg);
    }
    berechneMeister() {
        return formatPrice(this.meister);
    }
    berechneNull() {
        return formatPrice(0);
    }
}

/**
 * Berechnen des Wohnzuschlags je nach BAföG-Art
 * @param $this
 * @param aus
 */
function wohnzuschlagBerechnen($this, aus = false) {
    const wohn = new Wohnzuschuss();
    if (aus) {
        $this.el$('results.wohnzuschlag').value = wohn.null
        //console.log('Wohnzuschlag: ' + $this.el$('results.wohnzuschlag').value)
    }else {
        //console.log('wohnzuschuss: '+$this.el$('Ausbildung.art').value)
        if (!$this.el$('Ausbildung.beiEltern').value) { // beiEltern gesetzt?
            //console.log('Ausbildung.beiEltern leer')
        } else if ($this.el$('Ausbildung.art').value && $this.el$('Ausbildung.zeitmodell').value === 'vollzeit') { // Art gesetzt?
            //console.log($this.el$('Ausbildung.beiEltern').value)

            if ($this.el$('Ausbildung.beiEltern').value === 'ja') { //wohnt noch bei Eltern
                if ($this.el$('Ausbildung.art').value === 'student') { //Student
                    $this.el$('results.wohnzuschlag').value = wohn.student_eltern
                } else if ($this.el$('Ausbildung.art').value === 'schueler') { // Schüler
                    if ($this.el$('Ausbildung.ausbildung_vorr').value) { // ausbildung_vorr gesetzt?
                        if ($this.el$('Ausbildung.ausbildung_vorr').value === 'ja') {
                            if ($this.el$('Ausbildung.divschulez').value) { // divschulez gesetzt?
                                if ($this.el$('Ausbildung.divschulez').value === 'abend') { // Abendschule
                                    $this.el$('results.wohnzuschlag').value = wohn.null
                                } else { // Kolleg
                                    $this.el$('results.wohnzuschlag').value = wohn.null
                                }
                            } else { // divschulez nicht gesetzt
                                $this.el$('results.wohnzuschlag').value = wohn.null
                            }
                        } else if ($this.el$('Ausbildung.ausbildung_vorr').value === 'nein') {
                            if ($this.el$('Ausbildung.divschule').value) { // divschule gesetzt?
                                if ($this.el$('Ausbildung.divschule').value === 'allg_schule') { // allg_schule
                                    $this.el$('results.wohnzuschlag').value = wohn.null
                                } else { // fachschule
                                    $this.el$('results.wohnzuschlag').value = wohn.null
                                }
                            } else { // divschule nicht gesetzt
                                $this.el$('results.wohnzuschlag').value = wohn.null
                            }
                        }
                    } else { // ausbildung_vorr nicht gesetzt
                        $this.el$('results.wohnzuschlag').value = wohn.null
                    }
                } else { // meister...leer
                    $this.el$('results.wohnzuschlag').value = wohn.null
                }
            } else if ($this.el$('Ausbildung.beiEltern').value === 'nein') { //wohnt nicht bei Eltern
                //console.log('wohngeld2: '+$this.el$('Ausbildung.art').value)
                if ($this.el$('Ausbildung.art').value === 'student') {
                    $this.el$('results.wohnzuschlag').value = wohn.student_allein
                } else if ($this.el$('Ausbildung.art').value === 'schueler') {
                    if ($this.el$('Ausbildung.ausbildung_vorr').value) { // ausbildung_vorr gesetzt?
                        if ($this.el$('Ausbildung.ausbildung_vorr').value === 'ja') {
                            if ($this.el$('Ausbildung.divschulez').value) { // divschulez gesetzt?
                                if ($this.el$('Ausbildung.divschulez').value === 'abend') { // Abendschule
                                    $this.el$('results.wohnzuschlag').value = wohn.abend
                                } else { // Kolleg
                                    $this.el$('results.wohnzuschlag').value = wohn.kolleg
                                }
                            } else { // divschulez nicht gesetzt
                                $this.el$('results.wohnzuschlag').value = wohn.null
                            }
                        } else if ($this.el$('Ausbildung.ausbildung_vorr').value === 'nein') {
                            if ($this.el$('Ausbildung.divschule').value) { // divschule gesetzt?
                                if ($this.el$('Ausbildung.divschule').value === 'allg_schule') { // allg_schule
                                    $this.el$('results.wohnzuschlag').value = wohn.abitur
                                } else { // fachschule
                                    $this.el$('results.wohnzuschlag').value = wohn.fachschule
                                }
                            } else { // divschule nicht gesetzt
                                $this.el$('results.wohnzuschlag').value = wohn.null
                            }
                        }
                    } else { // ausbildung_vorr nicht gesetzt
                        $this.el$('results.wohnzuschlag').value = wohn.null
                    }
                } else { // meister...leer
                    $this.el$('results.wohnzuschlag').value = wohn.null
                }
            }
        } else {
            // keine Ausbildung ausgewählt, also 0
            $this.el$('results.wohnzuschlag').value = wohn.null
        }
    }
    //console.log('Wohnzuschlag: '+$this.el$('results.wohnzuschlag').value)
}

/**
 * Funktionen exportieren
 */
export {wohnzuschlagBerechnen};
